<template>
    <hal-gerador-relatorios formato-lista="Lista" produto-id="401"></hal-gerador-relatorios>
</template>

<script>
    export default {
        name: 'RelatorioPersonalizado'
    }
</script>

<style scoped lang="stylus">

</style>
